import moment from 'moment'
import { component_tool } from '@/tool'
const { WizLocationSelect } = component_tool

let componentName = 'siteOrderStatistic'

const columns = [
  {
    title: '预约编号',
    name: 'number',
    tableItem: {}
  },
  {
    title: '场地名称',
    name: 'name',
    searchItem: {},
    tableItem: {}
  },
  {
    title: '场地编号',
    name: 'code',
    searchItem: {},
    tableItem: {}
  },
  {
    title: '预约编号',
    name: 'number',
    searchItem: {}
  },
  {
    title: '城市',
    name: 'city',
    dataIndex: 'city',
    searchItem: {
      type: 'diy',
      diy: WizLocationSelect,
      showSearch: true,
      optionType: 'city'
    },
    tableItem: {},
  },
  {
    title: '预约人',
    name: 'fullName',
    dataIndex: 'fullName',
    tableItem: {}
  },
  {
    title: '联系电话',
    name: 'orderMobile',
    dataIndex: 'orderMobile',
    tableItem: {}
  },
  {
    title: '使用日期',
    name: 'useDate',
    dataIndex: 'useDate',
    tableItem: {}
  },
  {
    title: '使用类型',
    name: 'useType',
    dict: [
      { code: 0, codeName: '新产品培训' },
      { code: 1, codeName: '实操培训' },
      { code: 2, codeName: '岗位培训' },
      { code: 3, codeName: '区域会议' },
      { code: 4, codeName: '岗位认证' },
      { code: 5, codeName: '其他' },
    ],
    searchItem: {
      type: 'select'
    },
    tableItem: {}
  },
  {
    title: '是否核实',
    name: 'verifyResult',
    dataIndex: 'verifyResult',
    tableItem: {}
  },
  {
    title: '使用备注',
    name: 'remark',
    dataIndex: 'remark',
    tableItem: {
      width: 300
    }
  },
  {
    title: '预约日期',
    name: 'time',
    searchItem: {
      type: 'date~',
      showTime: false,
      format: 'YYYY-MM-DD'
    }
  }
]

const templateConfig = {
  mainProps: {},
  content: {
    name: 'WizTableList',
    params: {
      columns,
      searchBarProps: {
        dataFormat: (params) => {
          let value = Object.assign({}, params)
          if (value.time && value.time.length === 2) {
            value.start = moment(value.time[0]).format('YYYY-MM-DD')
            value.end = moment(value.time[1]).format('YYYY-MM-DD')
          }
          // delete value.time
          return value
        },
        buttonSort: ['export'],
        buttons: [
          {
            key: 'export',
            custom: true,
            params: { icon: 'export', children: '导出', type: 'export'},
            customOnClick: {
              key: 'action',
              params: {
                apiKey: 'export',
                apiParams: {}
              },
              formatParams: (rows, record, filter) => {
                return { ...filter }
              }
            }
          }
        ]
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: 'id',
        isScroll: true,
        loading: false
      },
      rowOperateSort: [],
      rowOperateView: []
    }
  }
}

const apis = {
  list: {
    path: `${componentName}/verifyStatistic`,
    payload: {
      key: `${componentName}@verifyStatistic`,
      apiParams: {}
    }
  },
  export: {
    path: `${componentName}/exportVerify`,
    payload: {
      key: `${componentName}@exportVerify`,
      apiParams: {}
    }
  }
}

let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
}

export { reduxTemplateCofig, templateConfig }
